import {
	Category, MediaLevel, Prisma
} from '.prisma/client';
import { MediaLevels } from '@/prisma/utils/media-levels';
import { MediaType } from '@/prisma/utils/media-type';
import { Tag } from '@/prisma/utils/tag';
import {
	FormControl, FormLabel, Input, Select, Text, Textarea 
} from '@chakra-ui/react';
import {
	ChangeEvent, ChangeEventHandler
} from 'react';
import CategorySelectControl from '../category/select-control';
import TagFormControl from '../tag/form-control';

type MediaFormProps = {
	name: string;
	onNameChange: (e: ChangeEvent<HTMLInputElement>) => void;
	description: string;
	onDescriptionChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
	type: MediaType;
	types: MediaType[];
	onTypeChange: (type: MediaType) => void;
	level: MediaLevel;
	levels: MediaLevels;
	onLevelChange: (e: ChangeEvent<HTMLSelectElement>) => void;
	duration: number;
	durations: number[];
	onDurationChange: (e: ChangeEvent<HTMLSelectElement>) => void;
	categories: Category[];
	selectedCategories: Category[];
	onCategoriesChange: (categories: Category[]) => void;
	tags: Tag[];
	onTagsChange: (tags: (Tag | Prisma.TagCreateInput)[]) => void;
	sourceUrl: string;
	initialRef: React.MutableRefObject<HTMLInputElement | undefined>;
	errorMessage: string;
}

export const MediaForm = ({
	name,
	onNameChange,
	description,
	onDescriptionChange,
	type,
	types,
	onTypeChange,
	level,
	levels,
	onLevelChange,
	duration,
	durations,
	onDurationChange,
	sourceUrl,
	initialRef,
	errorMessage,
	...props
}: MediaFormProps): any => {
	const handleTypeChange: ChangeEventHandler<HTMLSelectElement> = (e: ChangeEvent<HTMLSelectElement>) => {
		const target = e.target as HTMLSelectElement;

		const type =types.find(t => t.slug === target.value);
		onTypeChange(type);
	};

	return <>
		<FormControl>
			<FormLabel>Name</FormLabel>
			<Input
				ref={initialRef}
				placeholder="Name this media"
				value={name}
				onChange={onNameChange}
			/>
		</FormControl>
		<FormControl mt={4}>
			<FormLabel>Description</FormLabel>
			<Textarea
				placeholder="Describe this media"
				value={description || ''}
				onChange={onDescriptionChange}
			/>
		</FormControl>
		<FormControl mt={4}>
			<FormLabel>Type of yoga</FormLabel>
			<Select
				value={type.slug}
				onChange={handleTypeChange}
			>
				<option>Select a type of yoga</option>
				{types.map(_mt => <option
					key={_mt.id}
					value={_mt.slug}
				>{_mt.name}</option>)}
			</Select>
		</FormControl>
		<FormControl mt={4}>
			<FormLabel>Level</FormLabel>
			<Select
				value={level}
				onChange={onLevelChange}
			>
				<option>Select a level</option>
				{levels.map(_ml => <option
					key={_ml.key}
					value={_ml.value}
				>{_ml.value}</option>)}
			</Select>
		</FormControl>
		<CategorySelectControl
			categories={props.categories}
			selectedCategories={props.selectedCategories}
			onCategoriesChange={props.onCategoriesChange}
		/>
		<TagFormControl
			tags={props.tags}
			onTagsChange={props.onTagsChange}
		/>
		<FormControl mt={4}>
			<FormLabel>Source URL</FormLabel>
			<Input
				placeholder="Source URL"
				value={sourceUrl}
				disabled
			// onChange={handleSourceUrlChange}
			/>
		</FormControl>
		<FormControl mt={4}>
			<FormLabel>Duration</FormLabel>
			<Select
				value={duration}
				onChange={onDurationChange}
			>
				<option>Select a duration</option>
				{durations.map(_md => <option
					key={_md}
					value={_md}
				>{_md}</option>)}
			</Select>
		</FormControl>
		<Text
			my={4}
			color="red"
		>
			{errorMessage}
		</Text>
	</>;
};
